export default __webpack_public_path__ + "static/media/News1.63eb227c.jpg";